<nb-card>
  <nb-card-body [class.border-bottom]="shouldHaveBorderBottom">
    <div class="close-button-container"><button nbButton ghost size='tiny' (click)="close()" status="info" aria-label="Close message"><nb-icon pack="fas" icon="times"></nb-icon></button></div>
    <div class="left-section">
      <div class="notification-icon-container" [ngSwitch]="message.icon">
        <nb-icon
          *ngSwitchCase="notificationMessageIcon.checkmark"
          pack="fas"
          class="notification-icon-checkmark notification-icon"
          icon="check-circle"
        >
        </nb-icon>

        <div
          class="notification-icon-wrapper"
          *ngSwitchCase="notificationMessageIcon.fileExport"
        >
          <nb-icon
            pack="fas"
            class="notification-icon-export notification-icon notification-icon-small"
            icon="file-export"
          >
          </nb-icon>
        </div>
        <div
          class="notification-icon-wrapper"
          *ngSwitchCase="notificationMessageIcon.fileZip"
        >
          <nb-icon
            pack="fas"
            icon="file-archive"
            class="notification-icon-zip notification-icon notification-icon-small"
          ></nb-icon>
        </div>

        <nb-icon
          *ngSwitchCase="notificationMessageIcon.fail"
          pack="fas"
          icon="times-circle"
          class="notification-icon-fail notification-icon"
        ></nb-icon>
        <nb-icon
          *ngSwitchCase="notificationMessageIcon.email"
          pack="fa"
          icon="envelope-open-text"
          class="notification-icon"
        ></nb-icon>
      </div>
    </div>

    <div class="right-section">
      <div class="top-row">
        <div *ngIf="message?.date" class="notification-date">
          <p class="notification-date--bold notification-date--space-right" style="margin-right:10px">
            {{ message?.date | date: "MMMM dd, yyyy" }}
          </p>

          <p>
            {{ message?.date | date: "h:mm:ss a" }}
          </p>
        </div>

        <span>
          <span *ngIf="message?.status" class="notification-status">
            {{ message?.status }}
          </span>

          <span
            class="retry-content"
            *ngIf="message?.retry"
            (click)="retryOperation()"
          >
            {{ retry?.text || 'retry'| translation }}
          </span>
        </span>
      </div>

      <div *ngIf="message?.progress">
        <nb-progress-bar
          mode="determinate"
          status="primary"
          [value]="message?.progress"
          [displayValue]="false"
        ></nb-progress-bar>
      </div>

      <p [innerHTML]="message?.text"></p>

      <a *ngIf="message?.action" (click)="message.action()">{{
      message?.actionText || 'Yes' | translation
      }}</a>

      <a *ngIf="message?.link" [routerLink]="message?.link?.href">{{
        message?.link?.text
      }}</a>
    </div>
  </nb-card-body>
</nb-card>
